import { createFileRoute, Outlet } from "@tanstack/react-router";
import { m } from "@/lib/paraglide/messages.js";

// /staff/domains/*: the Domain group of the sidebar. Its pages share this crumb; there is no
// /staff/domains page, so the crumb names the group without linking to it.
export const Route = createFileRoute("/staff/_authenticated/domains")({
  staticData: { crumb: m.staff_nav_domains, crumbUnlinked: true },
  component: Outlet,
});
